import { useEffect, type ReactNode } from 'react';

import { initPostHogWeb } from './posthog';

/**
 * PostHog client provider (web).
 *
 * Initializes posthog-js on mount (client-side, so `window` exists — mirrors
 * DatadogProvider.web's useEffect init). posthog-js captures via its global
 * singleton, so unlike the native PostHogProvider there's no React context to
 * supply — we just init and render children.
 */
export const PostHogClientProvider = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    initPostHogWeb();
  }, []);

  return <>{children}</>;
};
